import { ChartArea } from "chart.js"

export function createGradient(
  ctx: CanvasRenderingContext2D,
  area: ChartArea,
  color: string | null | undefined,
  height?: number,
  strength?: number,
) {
  if (!color) return
  var gradient = ctx.createLinearGradient(0, 0, 0, height === undefined ? 600 : height)
  gradient.addColorStop(0, color.replace("1)", `${strength === undefined ? `0.4` : strength})`))
  gradient.addColorStop(1, color.replace("1)", `0)`))

  return gradient
}
